import * as React from "react";
import { Box } from "~/design-system/Box";
import { useBreakpoint } from "~/design-system/hooks";
import { SafeArea } from "~/design-system/SafeArea";
import { ActionBarPopup } from "~/screens/App/components/ActionBarPopup/ActionBarPopup";
import { createComponentHook } from "~/types";
import { useUserNotificationsStore } from "../../UserNotificationsScreen.store";
import { MultipleUserNotificationsActionMenu } from "./components/MultipleUserNotificationsActionMenu";

const useNotificationsSelectedItems = createComponentHook(() => {
  const { breakpoint } = useBreakpoint();
  const { selectedItems, setClearSelection } = useUserNotificationsStore(
    (state) => ({
      selectedItems: state.selectedItems,
      setClearSelection: state.setClearSelection,
    })
  );

  return {
    actions: {
      setClearSelection,
    },
    state: {
      breakpoint,
      selectedItems,
    },
  };
});

function NotificationsSelectedItems() {
  const { actions, state } = useNotificationsSelectedItems();

  if (state.selectedItems.length > 0) {
    return (
      <Box
        position="fixed"
        css={{
          bottom: state.breakpoint === "mobile" ? "5rem" : "1rem",
          left: "50%",
          transform: "translateX(-50%)",
        }}
      >
        <ActionBarPopup
          onClear={() => actions.setClearSelection(true)}
          itemsSelectedNumber={state.selectedItems.length}
          actionMenu={
            <MultipleUserNotificationsActionMenu data={state.selectedItems} />
          }
        />
        <SafeArea bottom />
      </Box>
    );
  }

  return null;
}

export { NotificationsSelectedItems };
